import React from 'react';

export const Code = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g stroke="#72706F" strokeWidth="1.5" fill="none" fillRule="evenodd" strokeLinecap="round" {...props}>
        <path d="m12 17 4-10M8 17l4-10M6 14h11M7 10h11" />
      </g>
    </svg>
  );
};

export default Code;
